import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useRightDrawerStore = defineStore('rightDrawer', () => {
  const isOpen = ref(false); // Tracks if the drawer is open
  const component = ref(null);
  const drawerTitle = ref(null);
  const drawerWidth = ref(null);
  const module = ref(null);
  const config = ref(null);

  const openDrawer = (data: any = null) => {
    module.value = data.module,
    component.value = data.component
    drawerTitle.value = data.drawerTitle
    drawerWidth.value = data.drawerWidth
    isOpen.value = true
    config.value = data.config
  };

  const closeDrawer = () => {
    isOpen.value = false;
  };

  return {
    isOpen,
    //drawerData,
    openDrawer,
    closeDrawer,
    component,
    drawerTitle,
    drawerWidth,
    module,
    config
  };
});
